import api from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout(kind, refId) {
  try {
    const { data } = await api.post("/payments/checkout", { kind, ref_id: refId, origin_url: window.location.origin });
    if (data.checkout_url) { window.location.href = data.checkout_url; return true; }
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Could not start checkout");
  }
  return false;
}
